import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { PaginationRequest } from './models/pagination/pagination.request.model';
import { RequestHelper } from '@shared/helpers/request.helper';

@Injectable({ providedIn: 'root' })
export class CenterApiService {
    constructor(
        private httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) { }

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}/centers`;
    }

    getAll(): Observable<any> {
        return this.httpClient.get<any>(`${this.url}/all`);
    }

    getCenters(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.get<any>(this.url, { params: options });
    }
    
    getOptions(req: PaginationRequest, body?: any): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.post<any>(`${this.url}/options`, body || {}, { params: options });
    }

    createCenter(center: any): Observable<any> {
        return this.httpClient.post<any>(this.url, center);
    }

    updateCenter(center: any): Observable<any> {
        return this.httpClient.put<any>(this.url, center);
    }

}
